export const clsx = (...classes) => {
    let i = 0;
    let str = '';
    while (i < classes.length) {
        const cls = classes[i];
        if (cls !== undefined && cls !== null && cls !== false) {
            if (str.length > 0)
                str += ' ';
            str += cls;
        }
        i++;
    }
    return str;
};
